import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useApi from '../../../hooks/useApi';
import { fetchMyActivities } from '../../../services/dashboardService';

export default function MyActivitiesTable() {
  const { data: activities, loading, error, callApi: fetchActivities } = useApi(fetchMyActivities, {showSuccessToast: false});
  const navigate = useNavigate();

  useEffect(() => {
    fetchActivities();
  }, [fetchActivities]);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200">
      <div className="p-6 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">My Recent Activities</h2>
      </div>
      <div className="px-6 py-4 overflow-x-auto">
        {loading ? (
          <div className="text-center text-gray-500 py-4">Loading activities...</div>
        ) : error ? (
          <div className="text-center text-red-500 py-4">{error}</div>
        ) : !activities || activities.length === 0 ? (
          <div className="text-center text-gray-400 py-4">No activities found.</div>
        ) : (
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-gray-500 uppercase">
                <th className="py-2 px-2">ID</th>
                <th className="py-2 px-2">Type</th>
                {/* <th className="py-2 px-2">Object ID</th> */}
                <th className="py-2 px-2">Action</th>
                <th className="py-2 px-2">Time</th>
                <th className="py-2 px-2">Description</th>
              </tr>
            </thead>
            <tbody>
              {activities.slice(0,5).map((act) => (
                <tr key={act.id} className="border-b last:border-0">
                  <td className="py-2 px-2">{act.id}</td>
                  <td className="py-2 px-2">{act.object_type}</td>
                  {/* <td className="py-2 px-2">{act.object_id}</td> */}
                  <td className="py-2 px-2">{act.action}</td>
                  <td className="py-2 px-2">{new Date(act.timestamp).toLocaleString()}</td>
                  <td className="py-2 px-2">{act.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      <div className="px-6 py-4 border-t border-gray-200">
        <button onClick={()=>navigate('/dashboard/my-activities')} className="text-primary-600 hover:text-primary-800 text-sm font-medium">
          View All 
        </button>
      </div>
    </div>
  );
}